import React, { useState } from 'react';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="flex items-center justify-between px-6 py-4 max-w-7xl mx-auto">
        <div className="flex items-center">
          <img src="/assets/logo.png" alt="Dr. Alvará" className="h-12 md:h-16 w-auto" />
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a href="#sobre" className="text-gray-600 hover:text-brand-dark transition-colors font-medium">Sobre</a>
          <a href="#servicos" className="text-gray-600 hover:text-brand-dark transition-colors font-medium">Serviços</a>
          <a href="#contato" className="text-gray-600 hover:text-brand-dark transition-colors font-medium">Contato</a>
          <a href="#contato" className="bg-brand-dark text-white px-6 py-2 rounded-md hover:bg-opacity-90 transition-all font-medium">
            Fale Conosco
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button className="text-brand-dark" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 px-6 py-4 space-y-4">
          <a href="#sobre" className="block text-gray-600 font-medium" onClick={() => setIsMenuOpen(false)}>Sobre</a>
          <a href="#servicos" className="block text-gray-600 font-medium" onClick={() => setIsMenuOpen(false)}>Serviços</a>
          <a href="#contato" className="block text-gray-600 font-medium" onClick={() => setIsMenuOpen(false)}>Contato</a>
          <a href="#contato" className="block bg-brand-dark text-white px-6 py-2 rounded-md text-center font-medium" onClick={() => setIsMenuOpen(false)}>
            Fale Conosco
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
